import {
  REFERRALS_SUMMARY_REQUEST_START,
  REFERRALS_SUMMARY_REQUEST_SUCCESS,
  REFERRALS_SUMMARY_REQUEST_FAIL,
  REFERRALS_DETAIL_REQUEST_START,
  REFERRALS_DETAIL_REQUEST_SUCCESS,
  REFERRALS_DETAIL_REQUEST_FAIL,
  REFERRALS_DETAIL_RESET,
  REFERRALS_SEARCH_REQUEST_START,
  REFERRALS_SEARCH_REQUEST_SUCCESS,
  REFERRALS_SEARCH_REQUEST_FAIL,
  REFERRALS_SEARCH_RESET,
  REFERRALS_MONTHS_DETAILS_REQUEST_START,
  REFERRALS_MONTHS_DETAILS_REQUEST_FAIL,
  REFERRALS_MONTHS_DETAILS_REQUEST_SUCCESS
} from './types';

import { convert, details, getMonthStatement, searchDetails } from './utils/convert';
import { affiliate, post, request } from '../session/actions';
import { getServicesErrorObj } from '../servicesDowntime/actions';
import { MonthStatementDataType } from '../../../core/types/GenrateMonthStatements';

const REFERRALS_SUMMARY_URL: string = `/v1/affiliate-portal/affiliate/referrals/graph-details`;
const REFERRALS_MONTH_DATA_URL: string = `/v1/affiliate-portal/affiliates/gettradeyearmonth`;
const REFERRALS_DETAILS_URL: string = `/v1/affiliate-portal/affiliates/referrals/referraltabulardata`;
const REFERRALS_SEARCH_DETAILS_URL: string = `/v1/affiliates/accounts/search`;

export const referralsSummaryRequestStart = () => ({
  type: REFERRALS_SUMMARY_REQUEST_START
});

export const referralsSummaryRequestFail = () => ({
  type: REFERRALS_SUMMARY_REQUEST_FAIL
});

export const referralsSummaryRequestSuccess = (payload: any) => ({
  type: REFERRALS_SUMMARY_REQUEST_SUCCESS,
  payload
});

export const referralsMonthDetailsRequestStart = () => ({
  type: REFERRALS_MONTHS_DETAILS_REQUEST_START
});

export const referralsMonthDetailsRequestFail = () => ({
  type: REFERRALS_MONTHS_DETAILS_REQUEST_FAIL
});

export const referralsMonthDetailsRequestSuccess = (payload: any) => ({
  type: REFERRALS_MONTHS_DETAILS_REQUEST_SUCCESS,
  payload
});

export const referralsDetailRequestStart = () => ({
  type: REFERRALS_DETAIL_REQUEST_START
});

export const referralsDetailRequestFail = () => ({
  type: REFERRALS_DETAIL_REQUEST_FAIL
});

export const referralsDetailRequestSuccess = (payload: any) => ({
  type: REFERRALS_DETAIL_REQUEST_SUCCESS,
  payload
});

export const referralsDetailReset = () => ({
  type: REFERRALS_DETAIL_RESET
});

export const referralsSearchRequestStart = () => ({
  type: REFERRALS_SEARCH_REQUEST_START
});

export const referralsSearchRequestSuccess = (payload: any) => ({
  type: REFERRALS_SEARCH_REQUEST_SUCCESS,
  payload
});

export const referralsSearchRequestFail = () => ({
  type: REFERRALS_SEARCH_REQUEST_FAIL
});

export const referralsSearchReset = () => ({
  type: REFERRALS_SEARCH_RESET
});

export const getReferralsSummary = (allAffiliatesNumbers: Array<string>, translate: Function) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(referralsSummaryRequestStart());
  dispatch(
    post(REFERRALS_SUMMARY_URL, {
      "affiliate_number": allAffiliatesNumbers?.length > 0 ? allAffiliatesNumbers : [affiliate()]
    })
  ).then((response: any) => {
    if (response && response.data) {
      const parsed: any = convert(response.data, translate);
      dispatch(referralsSummaryRequestSuccess(parsed));
      resolve(parsed);
    } else {
      dispatch(referralsSummaryRequestFail());
      reject();
    }
  }).catch((error: any) => {
    dispatch(referralsSummaryRequestFail());
    dispatch(getServicesErrorObj(error));
    reject(error);
  });
});

export const getReferralsMonths = (allAffiliatesNumbers: Array<string>) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(referralsMonthDetailsRequestStart());
  dispatch(
    post(REFERRALS_MONTH_DATA_URL, {
      "affiliate_number": allAffiliatesNumbers?.length > 0 ? allAffiliatesNumbers : [affiliate()]
    })
  ).then((response: any) => {
    if (response && response.data) {
      const parsed: MonthStatementDataType[] = getMonthStatement(response.data);
      dispatch(referralsMonthDetailsRequestSuccess(parsed));
      resolve(parsed);
    } else {
      dispatch(referralsMonthDetailsRequestFail());
      reject();
    }
  }).catch((error: any) => {
    dispatch(referralsMonthDetailsRequestFail());
    dispatch(getServicesErrorObj(error));
    reject();
  });
});

export const getReferralsDetail = (statement: any, referralsViewType: string, allAffiliatesNumbers: Array<string>, commissionViewType: string, translate: Function) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(referralsDetailRequestStart());
  dispatch(
    post(REFERRALS_DETAILS_URL, {
      'affiliate_number': allAffiliatesNumbers?.length > 0 ? allAffiliatesNumbers : [affiliate()],
      'statement_year': statement?.statementYear?.toString(),
      'statement_month': statement?.statementMonth?.toString(),
      'view_type': referralsViewType
    })
  ).then((response: any) => {
    if (response && response.data) {
      const parsed: any = {
        details: {},
        referralsViewType: commissionViewType,
        allAffiliatesNumbers: allAffiliatesNumbers
      };
      parsed.details = details(response.data, referralsViewType, commissionViewType, translate);
      dispatch(referralsDetailRequestSuccess(parsed));
      resolve(parsed);
    } else {
      dispatch(referralsDetailRequestFail());
      reject();
    }
  }).catch((error: any) => {
    dispatch(referralsDetailRequestFail());
    dispatch(getServicesErrorObj(error));
    reject(error);
  });
});

export const getReferralsSearchDetail = (searchValue: string, referralsViewType: string, allAffiliatesNumbers: Array<string>, translate: Function) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(referralsSearchRequestStart());
  dispatch(
    request({
      url: REFERRALS_SEARCH_DETAILS_URL,
      method: "POST",
      data: {
        'affiliate_number': allAffiliatesNumbers?.length > 0 && allAffiliatesNumbers[0] !== '' ? allAffiliatesNumbers : [affiliate()],
        'search_string': searchValue
      }
    })
  ).then((response: any) => {
    if (response && response.data) {
      const parsed: any = searchDetails(response.data, searchValue, referralsViewType, translate);
      dispatch(referralsSearchRequestSuccess(parsed));
      resolve(parsed);
    } else {
      dispatch(referralsSearchRequestFail());
      reject();
    }
  }).catch((error: any) => {
    dispatch(referralsSearchRequestFail());
    dispatch(getServicesErrorObj(error));
    reject(error);
  });
});

export type ReferralsSummaryAction = {
  type: string,
  payload?: any
};
